import { render, staticRenderFns } from "./xlDoorDevice.vue?vue&type=template&id=db5bc9a0&"
import script from "./xlDoorDevice.vue?vue&type=script&lang=js&"
export * from "./xlDoorDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports